import { render } from "./Navigation.vue?vue&type=template&id=53ec8bc5"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"
script.render = render

export default script